// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MenuGraph.css */
.closeButton {
    background: transparent;
    border: none;
    font-size: 1em;
    padding: 1%;
    cursor: pointer;
    color: red;
    /* Colore del testo */
    position: absolute;
    top: 10%;
    right: 10%;
}

.toggle {
    width: 85%;
    max-height: 17rem;
    overflow-y: auto;
    /* text-align: center;
    padding: .5rem;
    margin: auto;
    border: 1px solid gray;
    border-radius: .5rem; */
}

.menu-node {
    position: fixed;
    /* top: 2px; */
    left: -30%;
    /* Initially hidden out of the screen */
    height: 100%;
    width: 20%;
    background-color: #fff;
    border: 1px solid rgba(94, 91, 91, 0.719);
    /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); */
    transition: right 0.3s ease-in-out;
    z-index: 100;
    padding: 3vh 1vh;
    /*padding-bottom: 50vh;*/
    text-align: center;
    /* border-radius: 10px; */
    overflow-y: auto;
}

.menu-node p {
    word-wrap: break-word;
    /* Forza il testo a rompersi a capo se è troppo lungo */
}

.menu-node.open {
    left: 0px;
    /* Bring the menu inside the screen when it is open*/
}


.hideNode {
    width: 100%;
    padding: 3vh;
    margin-bottom: 3vh;
    font-weight: bold;
    border-radius: 4px;
    border: none;
    transition: all 0.5s;
    cursor: pointer;
    background-color: rgb(200, 200, 200);
    ;
    color: white;
    border: 1px solid rgb(200, 200, 200);
    ;
}

.hideNode:hover {
    background-color: white;
    color: rgb(200, 200, 200);
    ;
}

.showNodes {
    width: 100%;
    padding: 3vh;
    margin-bottom: 3vh;
    font-weight: bold;
    border-radius: 4px;
    border: none;
    transition: all 0.5s;
    cursor: pointer;
    background-color: rgb(200, 200, 200);
    ;
    color: white;
    border: 1px solid rgb(200, 200, 200);
    ;
}

.showNodes:hover {
    background-color: white;
    color: rgb(200, 200, 200);
    ;
}

.close {
    border: 2px solid orange;
    border-radius: .3rem;
}`, "",{"version":3,"sources":["webpack://./src/style/MenuGraph.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB;;;;2BAIuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,UAAU;IACV,uCAAuC;IACvC,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,yCAAyC;IACzC,6CAA6C;IAC7C,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,uDAAuD;AAC3D;;AAEA;IACI,SAAS;IACT,oDAAoD;AACxD;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,oCAAoC;;IAEpC,YAAY;IACZ,oCAAoC;;AAExC;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;;AAE7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,oCAAoC;;IAEpC,YAAY;IACZ,oCAAoC;;AAExC;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;;AAE7B;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB","sourcesContent":["/* MenuGraph.css */\r\n.closeButton {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 1em;\r\n    padding: 1%;\r\n    cursor: pointer;\r\n    color: red;\r\n    /* Colore del testo */\r\n    position: absolute;\r\n    top: 10%;\r\n    right: 10%;\r\n}\r\n\r\n.toggle {\r\n    width: 85%;\r\n    max-height: 17rem;\r\n    overflow-y: auto;\r\n    /* text-align: center;\r\n    padding: .5rem;\r\n    margin: auto;\r\n    border: 1px solid gray;\r\n    border-radius: .5rem; */\r\n}\r\n\r\n.menu-node {\r\n    position: fixed;\r\n    /* top: 2px; */\r\n    left: -30%;\r\n    /* Initially hidden out of the screen */\r\n    height: 100%;\r\n    width: 20%;\r\n    background-color: #fff;\r\n    border: 1px solid rgba(94, 91, 91, 0.719);\r\n    /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); */\r\n    transition: right 0.3s ease-in-out;\r\n    z-index: 100;\r\n    padding: 3vh 1vh;\r\n    /*padding-bottom: 50vh;*/\r\n    text-align: center;\r\n    /* border-radius: 10px; */\r\n    overflow-y: auto;\r\n}\r\n\r\n.menu-node p {\r\n    word-wrap: break-word;\r\n    /* Forza il testo a rompersi a capo se è troppo lungo */\r\n}\r\n\r\n.menu-node.open {\r\n    left: 0px;\r\n    /* Bring the menu inside the screen when it is open*/\r\n}\r\n\r\n\r\n.hideNode {\r\n    width: 100%;\r\n    padding: 3vh;\r\n    margin-bottom: 3vh;\r\n    font-weight: bold;\r\n    border-radius: 4px;\r\n    border: none;\r\n    transition: all 0.5s;\r\n    cursor: pointer;\r\n    background-color: rgb(200, 200, 200);\r\n    ;\r\n    color: white;\r\n    border: 1px solid rgb(200, 200, 200);\r\n    ;\r\n}\r\n\r\n.hideNode:hover {\r\n    background-color: white;\r\n    color: rgb(200, 200, 200);\r\n    ;\r\n}\r\n\r\n.showNodes {\r\n    width: 100%;\r\n    padding: 3vh;\r\n    margin-bottom: 3vh;\r\n    font-weight: bold;\r\n    border-radius: 4px;\r\n    border: none;\r\n    transition: all 0.5s;\r\n    cursor: pointer;\r\n    background-color: rgb(200, 200, 200);\r\n    ;\r\n    color: white;\r\n    border: 1px solid rgb(200, 200, 200);\r\n    ;\r\n}\r\n\r\n.showNodes:hover {\r\n    background-color: white;\r\n    color: rgb(200, 200, 200);\r\n    ;\r\n}\r\n\r\n.close {\r\n    border: 2px solid orange;\r\n    border-radius: .3rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
